import { ApicallOption, ApicallService } from "@core-services/apicall.service";
import { Injectable } from "@angular/core";
import { Term } from "@models/term";
import { Account } from "@models";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { NewAccount } from "../domain/entities/new_account.model";

@Injectable({
	providedIn: "root"
})
export class New_AccountRemote {
	constructor(private readonly apiCallService: ApicallService) {}

	public getAccount(account: NewAccount): Observable<NewAccount> {
		const newData = { ...account, terms: this.getSendTermsFormat(account) };
		const apiCallOptions = new ApicallOption(Account, newData);
		return this.apiCallService.post("user/settings", apiCallOptions).pipe(map((response) => response[0]));
	}

	private getSendTermsFormat(account: NewAccount): Object {
		const obj = {};
		account.terms.forEach((term: Term) => {
			obj[term.getType()] = term.hasSigned();
		});
		return obj;
	}
}
